// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608071847/js/" + chunkId + "." + {"44":"be7af5d5","225":"21c78ac7","481":"dbbe46a0","486":"931126bc","770":"ebdcb50f"}[chunkId] + ".0.30839085438365854.chunk.js";
};